import PinTypeEnum from "@/enums/PinTypeEnum";
import TreeNode from "@/types/TreeNode";
import { SelectModeStrategy } from "./ISelectModeStrategy";
import FilterTreeStore from "../FilterTreeStore";
import Pin from "@/types/FilterTree/Pin";
import IConfigTree from "@/interfaces/IConfigTree";
import FilterT from "@/types/FilterTree/FilterT";
import { StoreMediator } from '@/mediators/StoreMediator';

export abstract class MultiBaseMode extends SelectModeStrategy  {
    /** 
     * Constructeur avec paramètre
     * @param context Instance de FilterTree
     */
    public constructor(context: FilterTreeStore) {
        super(context);
        this.store.context.commit('setButtonState', { hasHistoricMode: true, hasPropertiesFilter: true, hasToggleCheckOnly: true, hasSelectAll: false, hasClearSelection: true });
    }

    public override Init(nodes : TreeNode[], pins : Pin[], isHistoricMode: boolean, isCheckOnly : boolean, configTree: IConfigTree, cleaned: boolean, grouping : FilterT) {
        for (let node of nodes) {
            if (cleaned)
                node = super.cleanNode(node);
            node.WithCheckBox = true;
        }

        if (configTree)
            nodes = (configTree as IConfigTree).Filter(nodes, isHistoricMode);

        if(grouping)
            this.store.context.commit('setGrouping', grouping);

        /** Force la déselection de noeuds dans les composants vue implémentant IFeature  */
        if (!this.store.context.getters['GetIsStoreMediatorDisabled'])
            StoreMediator.GetInstance().SelectNodeInComponents(undefined);

        this.setPins(nodes, pins, isHistoricMode, isCheckOnly);
    }

    protected abstract setPins(nodes : TreeNode[], pins : Pin[], isHistoricMode: boolean, isCheckOnly : boolean);

    public override SetPins(nodes : TreeNode[], pins : Pin[], isHistoricMode: boolean, isCheckOnly : boolean, cleaned: boolean){
        if (cleaned)
            nodes = super.Cleaned(nodes, isHistoricMode, isCheckOnly);

        this.setPins(nodes, pins, isHistoricMode, isCheckOnly);
    }

    public override StopPropagation(isContextMenu: boolean, node: TreeNode): boolean {
        return isContextMenu || !(node.WithCheckBox);
    }

    /** Passe en mode historique */
    public override SetHistoricMode(nodes : TreeNode[], pins : Pin[], isHistoricMode: boolean, isCheckOnly : boolean){
        let removePins: number[] = [];
                
        if (!isHistoricMode && pins.length > 0) {
            for (let node of nodes) {
                if (node.Depreciated) {
                    let selectIndex = node.Selections.findIndex(x => x.Affiliation === 0 && x.Type === PinTypeEnum.Tree);
                    if (selectIndex != -1) {
                        let removeIndex = pins.findIndex(x => x.Id === node.Selections[selectIndex].Id);
                        if (removeIndex !== -1)
                            removePins.push(pins[removeIndex].Id);
                    }
                }
            }
        }

        if (removePins.length > 0) {
            for (let node of nodes) {
                for (let removePin of removePins) {
                    let selectIndex = node.Selections.findIndex(x => x.Id === removePin);
                    if (selectIndex != -1) {
                        node.Selections.splice(selectIndex, 1);
                    }
                }
            }
            for (let removePin of removePins) {
                let removeIndex = pins.findIndex(x => x.Id === removePin);
                pins.splice(removeIndex, 1);
            }
        }

        for (let node of nodes) {
            this.UpdateNode(isHistoricMode, isCheckOnly, node);
        }

        this.store.context.commit('setBases', { nodes: nodes, pins: pins });
        this.UpdateInvolvedNodes(nodes, isHistoricMode);
    }
}